// export default NewProducts;
// import React, { useState, useEffect } from 'react';
// import Dropzone from 'react-dropzone';
// import { Form } from "react-bootstrap";
// import ReactQuill from "react-quill";
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';
// import '../NewProducts/NewProduct.css'; // Import your CSS file
// import { API_BASE_URL } from '../../../utils';
// import { useAuthHeaders } from '../../../components/Token';

// const NewProducts = () => {
//   const [propertyTitle, setPropertyTitle] = useState('');
//   const [images, setImages] = useState([]);
//   const [location, setLocation] = useState('');
//   const [totalArea, setTotalArea] = useState('');
//   const [propertyFacing, setPropertyFacing] = useState('');
//   const [price, setPrice] = useState('');
//   const [address, setAddress] = useState('');
//   const [categories, setCategories] = useState([]);
//   const [propertyCode, setPropertyCode] = useState('');
//   const headers = useAuthHeaders();
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [featureProperty, setFeatureProperty] = useState("");
//   const [cad, setCad] = useState([]);
//   const [submitCategory, setSubmitCategory] = useState("");
//   const [submitSubCategory, setSubmitSubCategory] =useState("")
//   const [subCategory, setSubCategory] = useState([]);
//   const [selectedSubCategory, setSelectedSubCategory] = useState("");
//   const [description, setDescription] = useState("");
//   const navigate = useNavigate();

//   const handleApplyForLeasing = (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("propertyType", submitSubCategory);
//     formData.append("propertyTitle", propertyTitle);
//     formData.append("location", location);
//     formData.append("type", submitCategory);
//     formData.append("totalArea", totalArea);
//     formData.append("featureProperty", featureProperty);
//     formData.append("propertyFacing", propertyFacing);
//     formData.append("propertyCode", propertyCode);
//     formData.append("price", price);
//     formData.append("address", address);
//     formData.append("description", description);

//     images.forEach((image) => formData.append("images", image));

//     axios.post(`${API_BASE_URL}/property/properties`, formData, { headers })
//       .then((result) => {
//         Swal.fire({
//           icon: "success",
//           title: "Product Added Successfully",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/newproductsViewPage");
//       })
//       .catch((error) => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data?.message,
//         });
//       });

//       if (!images) {
//         alert("Please select a file first!");
//         return;

//     }
//     };
//     const handleFileChange = (event) => {
//       setImages(event.target.files[0]);
//     };
//   const onDrop = (acceptedFiles) => {
//     if (images.length + acceptedFiles.length <= 10) {
//       setImages([...images, ...acceptedFiles]);
//     } else {
//       alert("You can upload a maximum of 10 photos");
//     }
//   };

//   const onCadChange = (e) => {
//     const files = Array.from(e.target.files);
//     setCad((oldArray) => [...oldArray, ...files]);
//   };

//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/getallcategory`, { headers })
//       .then(response => {
//         setCategories(response.data.data);
//       })
//       .catch(error => {
//         console.error("Error fetching categories:", error);
//       });
//   }, []);

//   const handleCategorySelect = (e) => {
//     const selectedCategory = e.target.value;
//     setSelectedCategory(selectedCategory);
//     const findCategoryName = categories.find((cat) => cat._id === selectedCategory);
//     setSubmitCategory(findCategoryName.categoryname);

//     axios.get(`${API_BASE_URL}/getsubcategorybycategory/${selectedCategory}`, { headers })
//       .then((response) => {
//         setSubCategory(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching subcategory data:", error);
//       });
//   };

//   const handleSubCategorySelect = (e) => {
//     const selectedSubCategory = e.target.value;
//     setSelectedSubCategory(selectedSubCategory);
//     const findCategoryName = subCategory.find((cat) => cat._id === selectedSubCategory);
//     setSubmitSubCategory(findCategoryName.subcategoryname);
//   };

//   return (
//     <>
//       <div className='text-center bg-white p-2 box-shadow'>
//         <h4>Add Property</h4>
//       </div>

//       <div className="row mt-2">
//         <div className='col-md-6'>
//           <div className="admin-page">
//             <form onSubmit={handleApplyForLeasing}>
//               <div className="form-group">
//                 <label className="label">Property Title</label>
//                 <input
//                   type="text"
//                   value={propertyTitle}
//                   onChange={(e) => setPropertyTitle(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Location</label>
//                 <input
//                   type="text"
//                   value={location}
//                   onChange={(e) => setLocation(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Category</label>
//                 <Form.Select
//                   id="category"
//                   aria-label="Default select example"
//                   className="my-2"
//                   required
//                   value={selectedCategory}
//                   onChange={handleCategorySelect}
//                 >
//                   <option value="">Select a category</option>
//                   {categories.map((category) => (
//                     <option key={category._id} value={category._id}>
//                       {category.categoryname}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </div>

//               <div className="form-group">
//                 <label className="label">Property Type</label>
//                 <Form.Select
//                   id="subCategory"
//                   aria-label="Default select example"
//                   className="my-2"
//                   required
//                   value={selectedSubCategory}
//                   onChange={handleSubCategorySelect}
//                 >
//                   <option value="">Select a subcategory</option>
//                   {subCategory.map((category) => (
//                     <option key={category._id} value={category._id}>
//                       {category.subcategoryname}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </div>

//               <div className="form-group">
//                 <label className="label">Total Area</label>
//                 <input
//                   type="text"
//                   value={totalArea}
//                   onChange={(e) => setTotalArea(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Property Facing</label>
//                 <input
//                   type="text"
//                   value={propertyFacing}
//                   onChange={(e) => setPropertyFacing(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Property Code</label>
//                 <input
//                   type="text"
//                   value={propertyCode}
//                   onChange={(e) => setPropertyCode(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Feature Property</label>
//                 <input
//                   type="text"
//                   value={featureProperty}
//                   onChange={(e) => setFeatureProperty(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Price</label>
//                 <input
//                   type="text"
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Address</label>
//                 <textarea
//                   rows="4"
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                   className="inputs"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="label">Property Images (Max 10)</label>
//                 <Dropzone onDrop={onDrop}>
//                   {({ getRootProps, getInputProps }) => (
//                     <div {...getRootProps()} className="dropzone">
//                       <input {...getInputProps()} type='file'/>
//                       <p>Drag 'n' drop some files here, or click to select files</p>
//                     </div>
//                   )}
//                 </Dropzone>
//                 <div className="images-preview">
//                   {images.map((file, index) => (
//                     <img
//                       key={index}
//                       src={URL.createObjectURL(file)}
//                       alt={`preview-${index}`}
//                       className="image-preview"
//                     />
//                   ))}
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label className="label">Property Description</label>
//                 <ReactQuill value={description} onChange={setDescription} theme="snow" />
//               </div>

//               <button type="submit" className="button">Apply for Leasing</button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NewProducts;

//=====================================================================================================================================
//=====================================================================================================================================
//=====================================================================================================================================
//=====================================================================================================================================
//=====================================================================================================================================
//=====================================================================================================================================
//=====================================================================================================================================

// import React, { useState, useEffect } from 'react';
// import Dropzone from 'react-dropzone';
// import { Form } from "react-bootstrap";
// import ReactQuill from "react-quill";
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';
// import '../NewProducts/NewProduct.css'; // Import your CSS file
// import { API_BASE_URL } from '../../../utils';
// import { useAuthHeaders } from '../../../components/Token';

// const NewProducts = () => {
//   const [propertyTitle, setPropertyTitle] = useState('');

//   const [images, setImages] = useState([]);
//   const [previewImages, setPreviewImages] = useState([]);

//   const [location, setLocation] = useState('');
//   const [totalArea, setTotalArea] = useState('');
//   const [propertyFacing, setPropertyFacing] = useState('');
//   const [price, setPrice] = useState('');
//   const [address, setAddress] = useState('');
//   const [categories, setCategories] = useState([]);
//   const [propertyCode, setPropertyCode] = useState('');
//   const headers = useAuthHeaders();
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [featureProperty, setFeatureProperty] = useState("");
//   const [submitCategory, setSubmitCategory] = useState("");
//   const [submitSubCategory, setSubmitSubCategory] = useState("");
//   const [subCategory, setSubCategory] = useState([]);
//   const [selectedSubCategory, setSelectedSubCategory] = useState("");
//   const [propertyDescription, setDescription] = useState("");
//   const [seoKeywords, setseoKeywords] = useState("")
//   const [seoDescription, setseoDescription] = useState("")
//   const [seoTitle, setseoTitle] = useState("")
//   const [name, setname] =useState("")
//   const [email,setemail] =useState("")
//   const [ mobile,setmobile] = useState("")
//   const navigate = useNavigate();

//   console.log("Image file",images)
//   console.log("image Preview Image ",previewImages)
//   console.log("----------------------------------------------")
//   console.log("----------------------------------------------")
//   console.log("----------------------------------------------")
//   console.log("----------------------------------------------")

//   // Handles form submission
//   const handleApplyForLeasing = async (e) => {
//     e.preventDefault();

//     // Creating FormData object
//     const formData = new FormData();
//     formData.append("propertyType", submitSubCategory);
//     formData.append("propertyTitle", propertyTitle);
//     formData.append("location", location);
//     formData.append("type", submitCategory);
//     formData.append("totalArea", totalArea);
//     formData.append("featureProperty", featureProperty);
//     formData.append("propertyFacing", propertyFacing);
//     formData.append("propertyCode", propertyCode);
//     formData.append("price", price);
//     formData.append("address", address);
//     formData.append("propertyDescription", propertyDescription);
//     formData.append("seoTitle", seoTitle);
//     formData.append("seoDescription", seoDescription);
//     formData.append("seoKeywords", seoKeywords);
//     formData.append("email", email);
//     formData.append("name", name);
//     formData.append(" mobile",  mobile);

//     // Appending images to FormData
//     images.forEach((image) => {
//       formData.append("propertyImages", image);
//     });

//     try {
//       // Sending POST request with formData
//       await axios.post(`${API_BASE_URL}/property/properties`, formData, {
//         headers
//       });

//       // Display success message and navigate to another page
//       Swal.fire({
//         icon: "success",
//         title: "Product Added Successfully",
//         showConfirmButton: false,
//         timer: 1500,
//       });
//       navigate("/addCoupen");
//     } catch (error) {
//       // Display error message if request fails
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: error.response.data?.message || "Failed to add product",
//       });
//     }
//   };

//   // Handles file drop in Dropzone
//   const onDrop = (acceptedFiles) => {
//     // Limiting to a maximum of 10 images

//     if (images.length + acceptedFiles.length <= 10) {
//       setImages([...images, ...acceptedFiles]);
//     } else {
//       alert("You can upload a maximum of 10 photos");
//     }

//     const files = Array.from(acceptedFiles.target.files);

//     files.forEach((file) => {
//       const reader = new FileReader();

//       reader.onload = () => {
//         if (reader.readyState == 2) {
//           setPreviewImages((oldArray) => [...oldArray, reader.result]);
//           setImages((oldArray) => [...oldArray, file]);
//         }
//       };

//       reader.readAsDataURL(file);
//     });

//   };

//   // Handles file change in input type file
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);

//     files.forEach((file) => {
//       const reader = new FileReader();

//       reader.onload = () => {
//         if (reader.readyState == 2) {
//           setPreviewImages((oldArray) => [...oldArray, reader.result]);
//           setImages((oldArray) => [...oldArray, file]);
//         }
//       };

//       reader.readAsDataURL(file);
//     });
//   };

//     useEffect(() => {
//       // Fetch categories on component mount
//       axios.get(`${API_BASE_URL}/getallcategory`, { headers })
//         .then(response => {

//           setCategories(response.data.data);
//         })
//         .catch(error => {
//           console.error("Error fetching categories:", error);
//         });
//     }, []);

//   // Handles category selection
//   const handleCategorySelect = (e) => {
//     const selectedCategory = e.target.value;
//     setSelectedCategory(selectedCategory);
//     const findCategoryName = categories.find((cat) => cat._id === selectedCategory);
//     setSubmitCategory(findCategoryName.categoryname);

//     // Fetch subcategories based on selected category
//     axios.get(`${API_BASE_URL}/getsubcategorybycategory/${selectedCategory}`, { headers })
//       .then((response) => {
//         setSubCategory(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching subcategory data:", error);
//       });
//   };

//   // Handles subcategory selection
//   const handleSubCategorySelect = (e) => {
//     const selectedSubCategory = e.target.value;
//     setSelectedSubCategory(selectedSubCategory);
//     const findCategoryName = subCategory.find((cat) => cat._id === selectedSubCategory);
//     setSubmitSubCategory(findCategoryName.subcategoryname);
//   };

//   return (
//     <>
//       <div className='text-center bg-white p-2 box-shadow'>
//         <h4>Add Property</h4>
//       </div>

//       <div className="row mt-2 d-flex">
//         <div className="admin-page">
//           <form onSubmit={handleApplyForLeasing} >

//             <div className="d-flex">

//               <div className='col-md-6  '>
//                 <div className="form-group">
//                   <label className="label">Property Title</label>
//                   <input
//                     type="text"
//                     value={propertyTitle}
//                     onChange={(e) => setPropertyTitle(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Location</label>
//                   <input
//                     type="text"
//                     value={location}
//                     onChange={(e) => setLocation(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Category</label>
//                   <Form.Select
//                     id="category"
//                     aria-label="Default select example"
//                     className="my-2"
//                     required
//                     value={selectedCategory}
//                     onChange={handleCategorySelect}
//                   >
//                     <option value="">Select a category</option>
//                     {categories.map((category) => (
//                       <option key={category._id} value={category._id}>
//                         {category.categoryname}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Property Type</label>
//                   <Form.Select
//                     id="subCategory"
//                     aria-label="Default select example"
//                     className="my-2"
//                     required
//                     value={selectedSubCategory}
//                     onChange={handleSubCategorySelect}
//                   >
//                     <option value="">Select a subcategory</option>
//                     {subCategory.map((category) => (
//                       <option key={category._id} value={category._id}>
//                         {category.subcategoryname}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Total Area</label>
//                   <input
//                     type="text"
//                     value={totalArea}
//                     onChange={(e) => setTotalArea(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Property Facing</label>
//                   <input
//                     type="text"
//                     value={propertyFacing}
//                     onChange={(e) => setPropertyFacing(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//               </div>
//               <div className="col-md-6 ms-2">
//                 <div className="form-group">
//                   <label className="label">Property Code</label>
//                   <input
//                     type="text"
//                     value={propertyCode}
//                     onChange={(e) => setPropertyCode(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Feature Property</label>
//                   <input
//                     type="text"
//                     value={featureProperty}
//                     onChange={(e) => setFeatureProperty(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Price</label>
//                   <input
//                     type="text"
//                     value={price}
//                     onChange={(e) => setPrice(e.target.value)}
//                     className="input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Address</label>
//                   <textarea
//                     rows="4"
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)}
//                     className="inputs"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="label">Property Images (Max 10)</label>
//                   <Dropzone onDrop={onDrop}>
//                     {({ getRootProps, getInputProps }) => (
//                       <div {...getRootProps()} className="dropzone">
//                         <input {...getInputProps()} type='file' onChange={handleFileChange} />
//                         <p>Drag 'n' drop some files here, or click to select files</p>
//                       </div>
//                     )}
//                   </Dropzone>

//                   {previewImages.map((productimages, index) => (
//                     <div key={index} className="mt-3 mr-2">
//                       <img
//                         src={productimages}
//                         alt={`Image Preview`}
//                         width="55"
//                         height="52  "

//                       />
//                       {/* <span className="fs-6" onClick={() => removeImage(index)}>
//               <CiCircleRemove />
//             </span> */}
//                     </div>
//                   ))}

//                   <div className="images-preview">
//                     {images.map((file, index) => (
//                       <img
//                         key={index}
//                         src={URL.createObjectURL(file)}
//                         alt={`preview-${index}`}
//                         className="image-preview"
//                       />
//                     ))}
//                   </div>
//                 </div>

//               </div>

//             </div>
//             <div className="form-group">
//               <label className="label">Property Description</label>
//               <ReactQuill value={propertyDescription} onChange={setDescription} theme="snow" />
//             </div>

//             <h4>Owner Details</h4>
//             <div className='d-flex ms-5 '>

//               <div className="form-group me-5 ms-5">
//                 <label className="label">Name</label>
//                 {/* <ReactQuill value={seoTitle} onChange={setseoTitle} theme="snow" /> */}
//                 <input
//                   type="text"
//                   value={name}
//                   onChange={(e) => setseoTitle(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//               <div className="form-group me-5 ms-5">
//                 <label className="label">Email</label>
//                 {/* <ReactQuill value={seoDescription} onChange={setseoDescription} theme="snow" /> */}
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setseoDescription(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//               <div className="form-group ms-5">
//                 <label className="label"> Mobile</label>
//                 {/* <ReactQuill value={seoKeywords} onChange={setseoKeywords} theme="snow" /> */}
//                 <input
//                   type="telephone"
//                   value={mobile}
//                   onChange={(e) => setseoKeywords(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//             </div>

//             <h4>Seo Details</h4>
//             <div className='d-flex ms-5 '>

//               <div className="form-group me-5 ms-5">
//                 <label className="label">SeoTitle</label>
//                 {/* <ReactQuill value={seoTitle} onChange={setseoTitle} theme="snow" /> */}
//                 <input
//                   type="text"
//                   value={seoTitle}
//                   onChange={(e) => setseoTitle(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//               <div className="form-group me-5 ms-5">
//                 <label className="label">SeoDescription</label>
//                 {/* <ReactQuill value={seoDescription} onChange={setseoDescription} theme="snow" /> */}
//                 <input
//                   type="text"
//                   value={seoDescription}
//                   onChange={(e) => setseoDescription(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//               <div className="form-group me-5 ms-5">
//                 <label className="label">SeoKeywords</label>
//                 {/* <ReactQuill value={seoKeywords} onChange={setseoKeywords} theme="snow" /> */}
//                 <input
//                   type="text"
//                   value={seoKeywords}
//                   onChange={(e) => setseoKeywords(e.target.value)}
//                   className="input"
//                   required
//                 />
//               </div>
//             </div>

//             <button type="submit" className="button">Apply for Leasing</button>
//           </form>
//         </div>

//       </div>
//     </>
//   );
// };

// export default NewProducts;
import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import "../NewProducts/NewProduct.css"; // Import your CSS file
import { API_BASE_URL } from "../../../utils";
import { useAuthHeaders } from "../../../components/Token";
import { WithContext as ReactTags } from "react-tag-input";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Watermark } from "@hirohe/react-watermark";

import { createCanvas, loadImage } from "canvas";
import { DatePicker } from "antd";

const applyWatermark = async (
  imageFile,
  text,
  textSize,
  textColor,
  opacity
) => {
  const canvas = createCanvas();
  const ctx = canvas.getContext("2d");
  const img = await loadImage(URL.createObjectURL(imageFile));

  canvas.width = img.width;
  canvas.height = img.height;

  ctx.drawImage(img, 0, 0);
  ctx.globalAlpha = opacity;
  ctx.font = `${textSize}px sans-serif`;
  ctx.fillStyle = textColor;

  // Calculate the position to center the text
  const textWidth = ctx.measureText(text).width;
  const x = (img.width - textWidth) / 2;
  const y = (img.height - textSize) / 2 + textSize;

  ctx.fillText(text, x, y);

  return canvas.toDataURL();
};

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const NewProducts = () => {
  const [propertyTitle, setPropertyTitle] = useState("");
  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [location, setLocation] = useState("");
  const [totalArea, setTotalArea] = useState("");
  const [propertyFacing, setPropertyFacing] = useState("");
  const [price, setPrice] = useState("");
  const [address, setAddress] = useState("");
  const [categories, setCategories] = useState([]);
  const [propertyCode, setPropertyCode] = useState("");
  const headers = useAuthHeaders();

  
  const [selectedCategory, setSelectedCategory] = useState("");
  const [featureProperty, setFeatureProperty] = useState(null);
  const [submitCategory, setSubmitCategory] = useState("");
  const [submitSubCategory, setSubmitSubCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [propertyDescription, setDescription] = useState("");
  const [seoKeywords, setSeoKeywords] = useState([]);
  const [seoDescription, setSeoDescription] = useState("");
  const [seoTitle, setSeoTitle] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [locationmap, setLocationmap] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendaracution, setShowCalendaracution] = useState(false);
  const [inspection_date, setInspection_date] = useState("");
  const [auction_date, setAuction_date] = useState("");
  console.log(auction_date,"auction_date")
  const [watermarkedImages, setWatermarkedImages] = useState([]);
  const navigate = useNavigate();

  const handleDelete = (i) => {
    setSeoKeywords(seoKeywords.filter((tag, index) => index !== i));
  };

  const handleAddition = (tag) => {
    setSeoKeywords([...seoKeywords, tag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = seoKeywords.slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setSeoKeywords(newTags);
  };

  // const handleApplyForLeasing = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("propertyType", submitSubCategory);
  //   formData.append("propertyTitle", propertyTitle);
  //   formData.append("location", location);
  //   formData.append("type", submitCategory);
  //   formData.append("totalArea", totalArea);
  //   formData.append("featureProperty", featureProperty);
  //   formData.append("propertyFacing", propertyFacing);
  //   formData.append("propertyCode", propertyCode);
  //   formData.append("price", price);
  //   formData.append("address", address);
  //   formData.append("propertyDescription", propertyDescription);
  //   formData.append("seoDetails.seoTitle", seoTitle);
  //   formData.append("seoDetails.seoDescription", seoDescription);
  //   formData.append(
  //     "seoDetails.seoKeywords",
  //     seoKeywords.map((tag) => tag.text).join(",")
  //   );
  //   formData.append("ownerDetails.email", email);
  //   formData.append("ownerDetails.name", name);
  //   formData.append("ownerDetails.mobile", mobile);

  //   images.forEach((image) => {
  //     formData.append("propertyImages", image);
  //   });

  //   try {
  //     await axios.post(`${API_BASE_URL}/property/properties`, formData, {
  //       headers,
  //     }
  //   ).then(res=>{

  //     console.log(res?.data?.data?.seoDetails[0])
  //     Swal.fire({
  //       icon: "success",
  //       title: res.data.data.message,
  //       showConfirmButton: false,
  //       timer: 1500,
  //     });
  //     navigate("/PropertyView");
  //   })

  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: error.response.data?.message || "Failed to add product",
  //     });
  //   }
  // };
  // const handleApplyForLeasing = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("propertyType", submitSubCategory);
  //   formData.append("propertyTitle", propertyTitle);
  //   formData.append("location", location);
  //   formData.append("type", submitCategory);
  //   formData.append("totalArea", totalArea);
  //   formData.append("featureProperty", featureProperty);
  //   formData.append("propertyFacing", propertyFacing);
  //   formData.append("propertyCode", propertyCode);
  //   formData.append("price", price);
  //   formData.append("address", address);
  //   formData.append("propertyDescription", propertyDescription);
  //   formData.append("ownerDetails.email", email);
  //   formData.append("ownerDetails.name", name);
  //   formData.append("ownerDetails.mobile", mobile);

  //   // Append seoDetails fields separately
  //   formData.append("seoDetails[seoTitle]", seoTitle);
  //   formData.append("seoDetails[seoDescription]", seoDescription);
  //   seoKeywords.forEach((tag, index) => {
  //     formData.append(`seoDetails[seoKeywords][${index}]`, tag.text);
  //   });

  //   images.forEach((image) => {
  //     formData.append("propertyImages", image);
  //   });

  //   try {
  //     await axios
  //       .post(`${API_BASE_URL}/property/properties`, formData, {
  //         headers: {
  //           ...headers,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       .then((res) => {
  //         console.log(res?.data?.data?.seoDetails[0]);
  //         Swal.fire({
  //           icon: "success",
  //           title: res.data.data.message,
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //         navigate("/PropertyView");
  //       });
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: error.response.data?.message || "Failed to add product",
  //     });
  //   }
  // };

  useEffect(() => {
    const processImages = async () => {
      const results = await Promise.all(
        images?.map((file) =>
          applyWatermark(file, "chennai auction properties", 15, "#020202", 0.7)
        )
      );
      setWatermarkedImages(results);
    };

    if (images && images.length > 0) {
      processImages();
    }
  }, [images]);

  // const handleApplyForLeasing = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("propertyType", submitSubCategory);
  //   formData.append("propertyTitle", propertyTitle);
  //   formData.append("location", location);
  //   formData.append("type", submitCategory);
  //   formData.append("totalArea", totalArea);
  //   formData.append("featureProperty", featureProperty);
  //   formData.append("propertyFacing", propertyFacing);
  //   formData.append("propertyCode", propertyCode);
  //   formData.append("price", price);
  //   formData.append("address", address);
  //   formData.append("propertyDescription", propertyDescription);
  //   formData.append("ownerDetails.email", email);
  //   formData.append("ownerDetails.name", name);
  //   formData.append("ownerDetails.mobile", mobile);

  //   // Append seoDetails fields separately
  //   formData.append("seoDetails[seoTitle]", seoTitle);
  //   formData.append("seoDetails[seoDescription]", seoDescription);
  //   seoKeywords.forEach((tag, index) => {
  //     formData.append(`seoDetails[seoKeywords][${index}]`, tag.text);
  //   });

  //   images.forEach((image) => {
  //     formData.append("propertyImages", image);
  //   });

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/property/properties`,
  //       formData,
  //       {
  //         headers: {
  //           ...headers,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     console.log(response?.data?.data?.seoDetails[0]);
  //     Swal.fire({
  //       icon: "success",
  //       title: response.data.data.message,
  //       showConfirmButton: false,
  //       timer: 1500,
  //     });
  //     navigate("/PropertyView"); // Ensure this triggers navigation correctly
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: error.response.data?.message || "Failed to add product",
  //     });
  //   }
  // };
  // const handleApplyForLeasing = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("propertyType", submitSubCategory);
  //   formData.append("propertyTitle", propertyTitle);
  //   formData.append("location", location);
  //   formData.append("type", submitCategory);
  //   formData.append("totalArea", totalArea);
  //   formData.append("featureProperty", featureProperty);
  //   formData.append("propertyFacing", propertyFacing);
  //   formData.append("propertyCode", propertyCode);
  //   formData.append("price", price);
  //   formData.append("address", address);
  //   formData.append("propertyDescription", propertyDescription);
  //   formData.append("ownerDetails.email", email);
  //   formData.append("ownerDetails.name", name);
  //   formData.append("ownerDetails.mobile", mobile);

  //   // Append seoDetails fields separately
  //   formData.append("seoDetails[seoTitle]", seoTitle);
  //   formData.append("seoDetails[seoDescription]", seoDescription);
  //   seoKeywords.forEach((tag, index) => {
  //     formData.append(`seoDetails[seoKeywords][${index}]`, tag.text);
  //   });

  //   images.forEach((image) => {
  //     formData.append("propertyImages", image);
  //   });

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/property/properties`,
  //       formData,
  //       {
  //         headers: {
  //           ...headers,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     // Add debugging statements
  //     console.log('API response:', response);
  //     console.log('API response data:', response.data);

  //     // Check if response.data and response.data.data are defined
  //     if (response?.data?.data) {
  //       console.log(response.data.data.seoDetails[0]);

  //       Swal.fire({
  //         icon: "success",
  //         title: response.data.data.message,
  //         showConfirmButton: false,
  //         timer: 1500,
  //       });

  //       navigate("/PropertyView"); // Ensure this triggers navigation correctly
  //     } else {
  //       throw new Error('Unexpected API response structure');
  //     }
  //   } catch (error) {
  //     console.error('API error:', error);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: error.response?.data?.message || "Failed to add product",
  //     });
  //   }
  // };
  const handleApplyForLeasing = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("propertyType", submitSubCategory);
    formData.append("propertyTitle", propertyTitle);
    formData.append("location", location);
    formData.append("type", submitCategory);
    formData.append("totalArea", totalArea);
    formData.append("featureProperty", featureProperty);
    formData.append("propertyFacing", propertyFacing);
    // formData.append("propertyCode", propertyCode);
    formData.append("price", price);
    formData.append("auction_date", auction_date);
    formData.append("inspection_date", inspection_date);
    formData.append("locationmap", locationmap);
    formData.append("address", address);
    formData.append("propertyDescription", propertyDescription);
    formData.append("ownerDetails.email", email || "");
    formData.append("ownerDetails.name", name || "");
    formData.append("ownerDetails.mobile", mobile || "");

    // Append seoDetails fields separately
    formData.append("seoDetails[seoTitle]", seoTitle || "");
    formData.append("seoDetails[seoDescription]", seoDescription || "");
    seoKeywords.forEach((tag, index) => {
      formData.append(`seoDetails[seoKeywords][${index}]`, tag.text || []);
    });

    images.forEach((image) => {
      formData.append("propertyImages", image);
    });

    try {
      const accesstoken = localStorage.getItem("accessToken")
      const headers = {
        Authorization: `Bearer ${accesstoken}`,
      };
      const response = await axios.post(
        `${API_BASE_URL}/property/properties`,
        formData,
        {
          headers
        }
      );

      // Log the entire response to see its structure
      console.log("Response:", response);

      if (response?.data?.data?.message) {
        Swal.fire({
          icon: "success",
          title: response.data.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/PropertyView"); // Ensure this triggers navigation correctly
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unexpected response structure",
        });
      }
    } catch (error) {
      // Log the error response to understand its structure
      console.error("Error response:", error.response);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response?.data?.message || "Failed to add product",
      });
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState == 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
          setImages((oldArray) => [...oldArray, file]);
        }
      };

      reader.readAsDataURL(file);
    });
  };
  const onDrop = (acceptedFiles) => {
    // Limiting to a maximum of 10 images

    if (images.length + acceptedFiles.length <= 10) {
      setImages([...images, ...acceptedFiles]);
    } else {
      alert("You can upload a maximum of 10 photos");
    }

    const files = Array.from(acceptedFiles.target.files);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState == 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
          setImages((oldArray) => [...oldArray, file]);
        }
      };

      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        setCategories(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const handleCategorySelect = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
    const findCategoryName = categories.find(
      (cat) => cat._id === selectedCategory
    );
    setSubmitCategory(findCategoryName.categoryname);

    axios
      .get(`${API_BASE_URL}/getsubcategorybycategory/${selectedCategory}`, {
        headers,
      })
      .then((response) => {
        console.log(response, "DSSSSSSSSSSSSSSSSSSSSSSSSS");
        setSubCategory(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching subcategory data:", error);
      });
  };

  const handleSubCategorySelect = (e) => {
    const selectedSubCategory = e.target.value;
    setSelectedSubCategory(selectedSubCategory);
    const findCategoryName = subCategory.find(
      (cat) => cat._id === selectedSubCategory
    );
    setSubmitSubCategory(findCategoryName.subcategoryname);
  };
  const handleSelect = (value) => {
    setFeatureProperty(value);
  };
  const handleSelectfacing = (value) => {
    setPropertyFacing(value);
  };
  return (
    <>
      <div className="text-center bg-white p-2 box-shadow">
        <h4>Add Property</h4>
      </div>

      <form onSubmit={handleApplyForLeasing}>
        <div className="row mt-2 d-flex">
          <div className="col-md-6">
            <div className="form-group">
              <label className="label">Property Title</label>
              <input
                type="text"
                value={propertyTitle}
                onChange={(e) => setPropertyTitle(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label">Location</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label">Type</label>
              <Form.Select
                id="category"
                aria-label="Default select example"
                className="my-2 border border-light input"
                required
                value={selectedCategory}
                onChange={handleCategorySelect}
              >
                <option value="">Select a Type </option>
                {categories.map((category) => (
                  <option key={category?._id} value={category?._id}>
                    {category?.categoryname}
                  </option>
                ))}
                {console.log(categories, "SSSSSSSSSSS")}
              </Form.Select>
            </div>

            <div className="form-group">
              <label className="label">Property Type</label>
              <Form.Select
                id="subCategory"
                aria-label="Default select example"
                className="my-2 border border-light input"
                required
                value={selectedSubCategory}
                onChange={handleSubCategorySelect}
              >
                <option value="">Select a Type Property</option>
                {subCategory.map((category) => (
                  <option key={category?._id} value={category?._id}>
                    {category?.subcategoryname}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="form-group">
              <label className="label">Total Area</label>
              <input
                type="text"
                value={totalArea}
                onChange={(e) => setTotalArea(e.target.value)}
                className="input"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* <div className="form-group">
              <label className="label">Property Facing</label>
              <input
                type="text"
                value={propertyFacing}
                onChange={(e) => setPropertyFacing(e.target.value)}
                className="input"
                required
              />
            </div> */}
            <div className="form-group">
              <label className="label">Property Facing</label>
              <Dropdown className="">
                <Dropdown.Toggle className="form-control w-100 text-start bg-white text-black border border-light input">
                  {propertyFacing || "Select Property Facing"}
                  <span style={{ float: "right" }}>
                    <RiArrowDropDownLine className="fs-3" />
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                  <Dropdown.Item onClick={() => handleSelectfacing("North")}>
                    North
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSelectfacing("South")}>
                    South
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSelectfacing("East")}>
                    East
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSelectfacing("West")}>
                    West
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {/* <div className="form-group">
              <label className="label">Property Code</label>
              <input
                type="text"
                value={propertyCode}
                onChange={(e) => setPropertyCode(e.target.value)}
                className="input"
                required
              />
            </div> */}
            {/* <div className="form-group">
              <label className="label">Feature Property</label>
              <Dropdown className="">
                <Dropdown.Toggle
                  className="from-control w-100 text-start bg-white text-black  "
                  id="dropdown-basic"
                  value={featureProperty}
                  >
                  Select Feature Property
                  <span style={{ float: "right" }}>
                    <RiArrowDropDownLine className="fs-3 " />
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                  <Dropdown.Item onClick={() => setFeatureProperty(true)}>
                    True
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() =>  setFeatureProperty(false)}>
                    False
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
            <div className="form-group">
              <label className="label">Feature Property</label>
              <Dropdown>
                <Dropdown.Toggle className="form-control w-100 text-start bg-white text-black border border-light input">
                  {featureProperty === null
                    ? "Select Feature Property"
                    : featureProperty.toString()}
                  <span style={{ float: "right" }}>
                    <RiArrowDropDownLine className="fs-3" />
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                  <Dropdown.Item onClick={() => handleSelect(true)}>
                    True
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSelect(false)}>
                    False
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="form-group">
              <label className="label">Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label className="label">Address</label>
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="input"
                required
              />
            </div>
          
            {/* <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              )}
            </Dropzone>

            <div className="preview-images">
              {previewImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`preview ${index}`}
                  className="preview-image"
                />
              ))}
            </div>
          </div> */}
          </div>
          <div className="row">
            <div className="col">

          <div>
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Inspection Date"
                checked={showCalendar} // Bind to state
                onChange={() => setShowCalendar(!showCalendar)} // Handle change event
              />
              {showCalendar && (
                <div className="mt-3">
                  <label>Select a Date:</label> <br />
                  <DatePicker
                    selected={inspection_date}
                    onChange={(date) => setInspection_date(date)} // Update selected date
                    inline // Shows the calendar inline
                  />
                </div>
              )}
            </div>
            </div>
            <div className="col">
            <div>
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Auction Date"
                checked={showCalendaracution} // Bind to state
                onChange={() => setShowCalendaracution(!showCalendaracution)} // Handle change event
              />
              {showCalendaracution && (
                <div className="mt-3">
                  <label>Select a Date:</label> <br />
                  <DatePicker
                    selected={auction_date}
                    onChange={(date) => setAuction_date(date)} // Update selected date
                    inline // Shows the calendar inline
                  />
                </div>
              )}
            </div>
            </div>
          </div>
        </div>
        <div className="form-group w-50 ms-2  ">
          <label className="label">Property Images (Max 10)</label>
          {/* <Watermark text="chennai acution properties"> */}
          <Dropzone onDrop={onDrop} className="ms-2">
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="dropzone">
                <input
                  {...getInputProps()}
                  type="file"
                  onChange={handleFileChange}
                />
                <p>Drag 'n' drop some files here, or click to select files</p>
              </div>
            )}
          </Dropzone>

          {/* </Watermark> */}
          {/* {previewImages.map((productimages, index) => (
            <div key={index} className="mt-3 mr-2">
             
                <img
                  src={productimages}
                  alt={`Image Preview`}
                  width="55"
                  height="52  "
                />
            </div>
          ))} */}

          {/* <div className="images-preview">
            {images?.map((file, index) => (
               <Watermark
               gutter={30}
               text="chennai acution properties"
               textSize={23}
               textColor="#020202"
               opacity={1}
               
             >
              <img

                key={index}
                src={URL.createObjectURL(file)}
                alt={`preview-${index}`}
                className="image-preview"
              />
              </Watermark>
            ))}
          </div> */}

          {/* <div className="images-preview">
            {images?.map((file, index) => (
              <Watermark
                key={index}
                gutter={30}
                text="chennai auction properties"
                textSize={23}
                textColor="#020202"
                opacity={1}
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt={`preview-${index}`}
                  className="image-preview"
                />
              </Watermark>
            ))}
          </div> */}
          <div className="images-preview">
            {watermarkedImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`preview-${index}`}
                className="image-preview"
              />
            ))}
          </div>
        </div>
        <div className="form-group">
          <label className="label">Property Description</label>
          <ReactQuill
            theme="snow"
            value={propertyDescription}
            onChange={setDescription}
            required
          />
        </div>
        <div className="form-group">
          <label className="label">Location </label>
          <input
            type="text"
            value={locationmap}
            onChange={(e) => setLocationmap(e.target.value)}
            className="input"
            placeholder="Enter your loaction link"
            required
          />
        </div>
        <div>
          <h4>Seo Details</h4>

          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="label">SEO Title</label>
                <input
                  type="text"
                  value={seoTitle}
                  onChange={(e) => setSeoTitle(e.target.value)}
                  className="input"
                  // required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group ">
                <label className="label">SEO Keywords</label>
                <ReactTags
                  tags={seoKeywords}
                  delimiters={delimiters}
                  handleDelete={handleDelete}
                  handleAddition={handleAddition}
                  handleDrag={handleDrag}
                  inputFieldPosition="inline"
                  editable
                  placeholder="Add new keyword"
                  className="input"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="label">SEO Description</label>
                <input
                  type="text"
                  value={seoDescription}
                  onChange={(e) => setSeoDescription(e.target.value)}
                  className="input"
                  // required
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          Owner Details
          <h4></h4>
          <div className="row ">
            <div className="col-md-4">
              <div className="form-group">
                <label className="label">Contact Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group ms-5 me-5">
                <label className="label">Contact Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  // required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="label">Contact Mobile</label>
                <input
                  type="text"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  className="input"
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <button className="btn btn-primary mt-3" type="submit">
          Apply for Leasing
        </button>
      </form>
    </>
  );
};

export default NewProducts;
